import { IconButton, Modal, Box } from '@material-ui/core'
import CancelIcon from '@material-ui/icons/Cancel'
import CustomButton from '../Button/CustomButton'
import ReactPlayer from 'react-player'
import React, { useState } from 'react'
import PropTypes from 'proptypes'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  videoWrap: {
    position: 'relative',
    paddingBottom: '56.25%',
    height: 0
  },
  video: {
    position: 'absolute',
    top: 0,
    left: 0
  },
  objectFitIE: {
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    '& $image': {
      opacity: 0,
      display: 'none'
    }
  },
  paper: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90vw',
    maxWidth: '1000px',
    backgroundColor: theme.colors.blue5,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(0),
    outline: 'none',
    [`${theme.breakpoints.down('sm')} and (orientation: portrait)`]: {
      width: '98vw'
    },
    [`${theme.breakpoints.down('sm')} and (orientation: landscape)`]: {
      width: '80vw'
    }
  },
  close: {
    position: 'absolute',
    right: -theme.spacing(5),
    top: -theme.spacing(5),
    color: theme.colors.white,
    zIndex: 1,
    fontSize: '2rem',
    [`${theme.breakpoints.down('sm')} and (orientation: portrait)`]: {
      right: -theme.spacing(2),
      top: -theme.spacing(6)
    },
    [`${theme.breakpoints.down('sm')} and (orientation: landscape)`]: {
      right: -theme.spacing(4),
      top: -theme.spacing(4)
    }
  },
  icon: {
    display: 'inline-flex',
    marginRight: theme.spacing(1),
    '& svg': {
      fill: 'currentColor'
    }
  },
  button: {
    margin: theme.spacing(1),
    whiteSpace: 'nowrap',
    padding: theme.spacing(0, 2, 0, 1.5),
    color: (props) => (props.color ? props.color : theme.colors.blue5),
    '&:hover': {
      color: (props) => (props.color ? props.color : theme.colors.blue5),
      backgroundColor: (props) => (props.color ? 'transparent' : theme.colors.white),
      boxShadow: (props) =>
        props.color
          ? '2px 2px 10px 0 rgba(1, 49, 63, 0.3), 0 1px 3px 0 rgba(1, 49, 63, 0.3)'
          : '2px 2px 10px 0 rgba(232, 236, 238, 1), 0 1px 3px 0 rgba(232, 236, 238, 1)',
      '&::after': {
        content: '""',
        position: 'absolute',
        width: '101%',
        height: '100%',
        left: -1,
        top: 0,
        backgroundColor: (props) => (props.color ? props.color : theme.colors.grey1),
        opacity: 0.3
      }
    }
  }
}))

function VideoButton(props) {
  const classes = useStyles(props)
  const [open, setOpen] = useState(false)

  const handleOpen = (e) => {
    e.preventDefault()
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <>
      <CustomButton
        color={props.cta.color}
        variant={props.cta.outlined ? 'outlined' : 'contained'}
        href={props.cta.href}
        title={props.cta.title}
        rel={props.cta.rel}
        target={props.cta.target}
        onClick={handleOpen}
      >
        <span className={classes.icon}>
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19">
            <g fill="inherit" fillRule="evenodd">
              <path
                d="M9 .75c4.556 0 8.25 3.694 8.25 8.25 0 4.557-3.694 8.25-8.25 8.25S.75 13.557.75 9C.75 4.444 4.444.75 9 .75zM6.634 5.873v6l6-3.158-6-2.842z"
                transform="translate(-678 -391) translate(659 379) translate(19 12.5)"
              />
            </g>
          </svg>
        </span>
        {props.cta.text}
      </CustomButton>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="video-modal"
        aria-describedby="video-modal"
      >
        <Box className={classes.paper}>
          <IconButton onClick={handleClose} className={classes.close}>
            <CancelIcon fontSize="inherit" />
          </IconButton>
          <div className={classes.videoWrap}>
            <ReactPlayer
              className={classes.video}
              controls
              playing={true}
              height="100%"
              width="100%"
              url={props.videoUrl}
            />
          </div>
        </Box>
      </Modal>
    </>
  )
}

export default VideoButton

VideoButton.propTypes = {
  videoUrl: PropTypes.string,
  cta: PropTypes.shape({
    text: PropTypes.string,
    href: PropTypes.string,
    rel: PropTypes.string,
    target: PropTypes.string,
    title: PropTypes.string
  })
}
